(function () {
  'use strict';

  function elements(ctx) {
    var methodSelector = document.getElementById('zug-method-selector');
    return {
      list: document.getElementById('zug-basic-upload-list'),
      note: document.getElementById('zug-basic-upload-note'),
      noteInput: document.getElementById('zug-basic-note-input'),
      methodSelector: methodSelector,
      instantCard: methodSelector ? methodSelector.querySelector('[data-method="instant_proof"]') : null,
      emailCard: methodSelector ? methodSelector.querySelector('[data-method="email_later"]') : null,
      reorderCard: methodSelector ? methodSelector.querySelector('[data-method="reorder"]') : null,
      standardPreviewFile: ctx.uploadPreview ? ctx.uploadPreview.querySelector('.zug-modal__preview-file') : null,
      formats: ctx.uploadZone ? ctx.uploadZone.querySelector('.zug-modal__upload-formats') : null
    };
  }

  function render(ctx) {
    var els = elements(ctx);
    if (els.standardPreviewFile) els.standardPreviewFile.style.display = 'none';
    if (!els.list) return;
    els.list.innerHTML = '';
    ctx.state.files.forEach(function (entry, index) {
      var row = document.createElement('div');
      var name = document.createElement('span');
      var remove = document.createElement('button');
      row.className = 'zug-modal__preview-file';
      row.style.marginBottom = index === ctx.state.files.length - 1 ? '0' : '8px';
      name.className = 'zug-modal__preview-name';
      name.textContent = (index + 1) + '. ' + entry.name;
      remove.type = 'button';
      remove.className = 'zug-modal__preview-remove';
      remove.setAttribute('data-basic-remove-index', String(index));
      remove.setAttribute('aria-label', 'Remove ' + entry.name);
      remove.textContent = '×';
      row.appendChild(name);
      row.appendChild(remove);
      els.list.appendChild(row);
    });
    els.list.style.display = ctx.state.files.length ? 'block' : 'none';
  }

  function reset(ctx) {
    var els = elements(ctx);
    ctx.state._basic_upload = false;
    ctx.state._multiple_files = false;
    if (ctx.uploadInput) ctx.uploadInput.removeAttribute('multiple');
    if (els.list) {
      els.list.innerHTML = '';
      els.list.style.display = 'none';
    }
    if (els.note) els.note.style.display = 'none';
    if (els.noteInput) els.noteInput.value = '';
    if (els.standardPreviewFile) els.standardPreviewFile.style.display = '';
    if (els.methodSelector) els.methodSelector.style.display = '';
    if (els.instantCard) {
      els.instantCard.style.display = '';
      var instantTitle = els.instantCard.querySelector('.zug-method-card__title');
      var instantDesc = els.instantCard.querySelector('.zug-method-card__desc');
      var instantBadge = els.instantCard.querySelector('.zug-method-card__badge');
      if (instantTitle) instantTitle.textContent = 'Instant Proof';
      if (instantDesc) instantDesc.textContent = 'Upload artwork now and approve a digital proof before checkout.';
      if (instantBadge) instantBadge.style.display = '';
    }
    if (els.emailCard) {
      var emailTitle = els.emailCard.querySelector('.zug-method-card__title');
      if (emailTitle) emailTitle.textContent = 'Email Artwork Later';
    }
    if (els.reorderCard) els.reorderCard.style.display = '';
    if (els.formats) els.formats.textContent = 'PNG, JPG, PDF, AI, SVG, PSD accepted';
    ctx.modal.querySelectorAll('[data-action="skip"]').forEach(function (button) {
      button.style.display = '';
    });
  }

  function apply(ctx, options) {
    if (!options || !options.basic_upload) return;
    var els = elements(ctx);
    ctx.state._basic_upload = true;
    ctx.state._multiple_files = !!options.multiple_files;
    if (ctx.uploadInput && ctx.state._multiple_files) ctx.uploadInput.setAttribute('multiple', 'multiple');
    if (els.instantCard) {
      var instantTitle = els.instantCard.querySelector('.zug-method-card__title');
      var instantDesc = els.instantCard.querySelector('.zug-method-card__desc');
      var instantBadge = els.instantCard.querySelector('.zug-method-card__badge');
      if (instantTitle) instantTitle.textContent = 'Upload Artwork';
      if (instantDesc) instantDesc.textContent = ctx.state._multiple_files
        ? 'Upload one or more artwork files now. Files stay in the order selected.'
        : 'Upload your artwork now.';
      if (instantBadge) instantBadge.style.display = 'none';
    }
    if (els.emailCard) {
      var emailTitle = els.emailCard.querySelector('.zug-method-card__title');
      if (emailTitle) emailTitle.textContent = 'Upload Later';
    }
    if (els.reorderCard) els.reorderCard.style.display = 'none';
    if (els.formats && ctx.state._multiple_files) {
      els.formats.textContent = 'PNG, JPG, PDF, AI, SVG, PSD accepted · multiple files allowed';
    }
    if (els.note) els.note.style.display = 'block';
    ctx.modal.querySelectorAll('[data-action="skip"]').forEach(function (button) {
      button.style.display = 'none';
    });
  }

  function select(ctx, fileList) {
    var files = Array.prototype.slice.call(fileList || []).filter(function (file) {
      return file && file.name;
    });
    if (!files.length) return;
    if (!ctx.state._multiple_files) files = files.slice(0, 1);
    ctx.state.files = files.map(function (file) {
      return { name: file.name, file: file, url: null };
    });
    if (ctx.uploadZone) ctx.uploadZone.style.display = 'none';
    if (ctx.uploadPreview) ctx.uploadPreview.style.display = 'block';
    render(ctx);
    if (ctx.uploadSubmit) ctx.uploadSubmit.disabled = false;
    ctx.hideError(ctx.uploadErrorEl);
  }

  function remove(ctx, index) {
    ctx.state.files.splice(index, 1);
    render(ctx);
    if (!ctx.state.files.length) {
      if (ctx.uploadInput) ctx.uploadInput.value = '';
      if (ctx.uploadZone) ctx.uploadZone.style.display = 'block';
      if (ctx.uploadPreview) ctx.uploadPreview.style.display = 'none';
      if (ctx.uploadSubmit) ctx.uploadSubmit.disabled = true;
    }
  }

  function submit(ctx) {
    if (!ctx.state.files.length) {
      ctx.showError(ctx.uploadErrorEl, 'Please choose at least one artwork file.');
      return;
    }
    var note = document.getElementById('zug-basic-note-input');
    window.__ZUG_UPLOAD = {
      artwork_mode: 'upload_artwork',
      files: ctx.state.files.map(function (entry) {
        return { name: entry.name, file: entry.file };
      }),
      approved: false,
      note: note ? note.value.trim() : '',
      target_width_in: ctx.state.target_width_in,
      target_height_in: ctx.state.target_height_in
    };
    var callback = ctx.state.onSaved;
    ctx.closeModal();
    setTimeout(function () {
      if (typeof callback === 'function') callback();
    }, 50);
  }

  window.ZugBasicArtworkUpload = {
    apply: apply,
    remove: remove,
    reset: reset,
    select: select,
    submit: submit
  };
})();
